import type { NewsType, ProductCategoryType, ProductContentType } from '@/types/domains/index';

export class TopPresenter {
  // composable 側が同期なので Presenter も同期にする。computed から使うため await できない
  getProductContentsByCategory(
    category: ProductCategoryType.RequestCategory
  ): ProductContentType.ProductContent[] {
    return useProductContent().getProductContentsByCategory(category);
  }

  /** 商品のカテゴリID。`PRODUCT_CODE_TO_CATEGORY_ID` を正とし、表に無い商品コードは API の値を使う */
  resolveCategoryId(productContent: ProductContentType.ProductContent): number {
    return useProductContent().resolveCategoryId(productContent);
  }

  getImportantNews(): NewsType.News[] {
    return useNews().getImportantNews();
  }
}
